/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class FileCodeIcon extends BaseIcon {
  getChildren = () => [
    <polygon fill={ this.getColor() } points="15 12.55 15 0 1 0 1 16 11.55 16 15 12.55"/>,
    <polygon fill="#fff" points="3.812 8 6 5.879 5.094 5 2 8 5.094 11 6 10.121 3.812 8"/>,
    <polygon fill="#fff" points="10.906 5 10 5.879 12.188 8 10 10.121 10.906 11 14 8 10.906 5"/>,
    <polygon fill="#fff" points="7 12 8 12 9 4 8 4 7 12"/>
  ]
  getViewBox = () => '0 0 16 16'
}
